import { mapIndexed } from '@mews-commander/utils';

// @ts-expect-error $TSFixMeError: Parameter 'productId' implicitly has an 'any' type.
export const mapProductCountsToArray = mapIndexed(({ unitCount }: $TSFixMe, productId) => ({
    productId,
    unitMultiplier: unitCount,
}));
